/**
 * Created by linjianxi on 2016/11/10.
 */
export const initPayT = (state) => {
  return state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/pay_test/getter.js